<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["profile"] }}</p>
      </div>
      <div class="content_title">
        {{ this.$store.getters.TRANSLATIONS["enter_your_personal"] }}
      </div>
      <img :src="defaultImage" class="defaultImage" />

      <input
        type="text"
        v-model="firstName"
        :placeholder="this.$store.getters.TRANSLATIONS['first_name']"
        class="firstName"
        autocomplete="off"
      />
      <input
        type="text"
        v-model="lastName"
        :placeholder="this.$store.getters.TRANSLATIONS['last_name']"
        class="lastName"
        autocomplete="off"
      />
      <input
        type="text"
        v-model="email"
        :placeholder="this.$store.getters.TRANSLATIONS['email']"
        class="email"
        autocomplete="off"
      />
      <!-- <input
        type="tel"
        v-mask="['+1 (###) ###-####']"
        v-model="telephone"
        placeholder="Phone"
        class="phone"
        autocomplete="off"
      />-->
      <input
        type="tel"
        v-model="telephone"
        :placeholder="this.$store.getters.TRANSLATIONS['phone']"
        class="phone"
        autocomplete="off"
      />
      <!-- <input
        type="text"
        v-model="language"
        :placeholder="this.$store.getters.TRANSLATIONS['language']"
        class="language"
        autocomplete="off"
      /> -->
      <!-- <div class="item">
        <select v-model="language" class="language">
          <option
            v-for="item in languageList"
            v-bind:key="item.id"
            v-bind:value="item.name"
            :disabled="item.id === -1"
          >
            {{ item.name }}
          </option>
        </select>
      </div> -->
      <input
        type="password"
        v-model="password"
        :placeholder="this.$store.getters.TRANSLATIONS['password']"
        class="password"
        autocomplete="new-password"
        v-if="!config.privateSignUp"
      />
      <input
        type="password"
        v-model="passwordConfirm"
        :placeholder="this.$store.getters.TRANSLATIONS['password_confirm']"
        class="password"
        autocomplete="new-password"
        v-if="!config.privateSignUp"
      />
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="update()" class="button">
        {{ this.$store.getters.TRANSLATIONS["save"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar></parkenda-toolbar>
  </div>
</template>

<script>
let privateEmail = "";
let privateFirstName = "";
let privateLastName = "";
export default {
  beforeCreate: function () {
    console.log("before created");
    if (this.$route.query.token) {
      const token = this.$route.query.token;
      this.$http
        .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
          headers: {
            "x-access-token": token
          }
        })
        .then((response) => {
          console.log("Get current user response:");
          console.log(response);
          if (response.data) {
            this.$store.dispatch("SAVE_USER", response.data);
            this.language = response.data.language;
            this.barcode = response.data.barcode;
            this.telephone = response.data.telephone;
            this.email = response.data.email;
            this.firstName = response.data.firstName;
            this.lastName = response.data.lastName;
            this.$storage.set("parkendaToken", token);

            if (response.data.firstName.startsWith("00000")) {
              privateFirstName = response.data.firstName;
            }
            if (response.data.lastName.startsWith("00000")) {
              privateLastName = response.data.lastName;
            }
            if (response.data.email.startsWith("00000")) {
              privateEmail = response.data.email;
            }
          }
        })
        .catch((error) => {
          this.$router.push("login");
        });
    } else if (
      !this.$storage.get("parkendaToken") ||
      !this.$store.getters.USER
    ) {
      this.$router.push("/login");
    }
  },
  data() {
    console.log("data");
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      defaultImage: require("@/assets/new_design/default_image.png"),
      // languageList: [
      //   {
      //     name: this.$store.getters.TRANSLATIONS["select_language"],
      //     id: -1
      //   },
      //   {
      //     name: "en",
      //     id: 1
      //   },
      //   {
      //     name: "fr",
      //     id: 2
      //   }
      // ],
      telephone:
        this.$store.getters.USER && this.$store.getters.USER.telephone
          ? this.$store.getters.USER.telephone
          : null,
      email:
        this.$store.getters.USER && this.$store.getters.USER.email
          ? this.$store.getters.USER.email.startsWith("00000")
            ? null
            : this.$store.getters.USER.email
          : null,
      lastName:
        this.$store.getters.USER && this.$store.getters.USER.lastName
          ? this.$store.getters.USER.lastName.startsWith("00000")
            ? null
            : this.$store.getters.USER.lastName
          : null,
      firstName:
        this.$store.getters.USER && this.$store.getters.USER.firstName
          ? this.$store.getters.USER.firstName.startsWith("00000")
            ? null
            : this.$store.getters.USER.firstName
          : null,
      password: "",
      passwordConfirm: "",
      language:
        this.$store.getters.USER && this.$store.getters.USER.language
          ? this.$store.getters.USER.language
          : null,

      back: () => {
        this.$router.go(-1);
      },
      update: () => {
        let error;
        if (!this.config.privateSignUp && !this.firstName) {
          error = this.$store.getters.TRANSLATIONS["please_set_first_name"];
        }
        if (!this.config.privateSignUp && !this.lastName) {
          error = this.$store.getters.TRANSLATIONS["please_set_last_name"];
        }
        if (!this.config.privateSignUp && !this.validateEmail(this.email)) {
          error = this.$store.getters.TRANSLATIONS["please_set_valid_email"];
        }
        if (!this.telephone) {
          error = this.$store.getters.TRANSLATIONS["phone_empty"];
        }
        if (this.$route.query.token && !this.password) {
          error = this.$store.getters.TRANSLATIONS["you_need_to_set_password"];
        }
        if (this.password && this.password.length < 6) {
          error = this.$store.getters.TRANSLATIONS["password_length"];
        }
        if (this.password && this.password !== this.passwordConfirm) {
          error = this.$store.getters.TRANSLATIONS["passwords_do_not_match"];
        }

        if (error) {
          this.$modal.show("dialog", {
            text: error,
            buttons: [
              {
                title: "OK"
              }
            ]
          });
        } else {
          const timeout = setTimeout(() => {
            this.loading = true;
          }, 0);
          let query = {
            firstName: this.firstName,
            lastName: this.lastName,
            telephone: this.telephone,
            email: this.email,
            language: this.language
          };
          if (this.password) {
            query.newPassword = this.password;
          }

          if (this.config.privateSignUp) {
            query.firstName = this.firstName
              ? this.firstName
              : this.$store.getters.USER.firstName;
            query.lastName = this.lastName
              ? this.lastName
              : this.$store.getters.USER.lastName;
            query.email = this.email
              ? this.email
              : this.$store.getters.USER.email;

            query.newPassword = this.telephone;
          }
          this.$http
            .post(
              `${process.env.SERVER_URL}/69E378C404C74A98AAEF7FA160EEF424`,
              query,
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Profile update response:");
              console.log(response);
              let currentUser = this.$store.getters.USER;

              currentUser.telephone = this.telephone;
              currentUser.email = this.email;
              currentUser.firstName = this.firstName;
              currentUser.lastName = this.lastName;
              currentUser.language = this.language;

              this.$store.dispatch("SAVE_USER", currentUser);

              if (this.$store.getters.USER_HAVE_ACTIVE_PARKING) {
                if (this.$route.name !== "CurrentParking") {
                  this.$router.push("/currentParking");
                }
              } else {
                if (this.$route.name !== "ParkendaValet") {
                  this.$router.push("/parkendaValet");
                }
              }
              this.$router.go();
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["profile_update_failed"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                text = error.response.data.message;
              }
              const modalId = this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK",
                    handler: () => {
                      this.$modal.hide("dialog");
                    }
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
            });
        }
      }
    };
  },
  methods: {
    validateEmail: (email) => {
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
input {
  margin: 0px 17vw 3vh;
  width: 65%;
  float: left;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
input::placeholder {
  color: rgba(114, 174, 255, 1);
}
select {
  width: 60%;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
.defaultImage {
  margin: 0 auto;
  width: 50vw;
  height: auto;
}
.item {
  margin: 0 auto;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue